import RestService from './RestService';
import Username from './UsernameService';
import Password from './PasswordService';
import IdLessRestService from './IdLessRestService';

export default class UserProfile extends IdLessRestService {
    constructor() {
        super('/api/v1/user/profile');
    }

    update(entity: any) {
        return this.put(`${this.baseUrl}/`, entity);
    }

    PasswordService() {
        return new Password(this);
    }

    UsernameService() {
        return new Username(this);
    }
}
